import TemplateContents from './TemplateContents';

export default class extends TemplateContents {
  constructor(param) {
    super(param);

    // Capture then immediately strip any #hash from the URL (this runs as
    // soon as Common.initContainer() creates this page's controller, i.e.
    // right at DOMContentLoaded). Leaving the hash in the URL lets the
    // browser's native scroll-to-fragment re-fire on later layout shifts
    // (e.g. images finishing loading), which fights our own scroll below
    // and produced a "content jumps by roughly the anchor's own offset"
    // symptom. With the hash removed, only anchorScroll() (run after
    // everything has loaded) ever moves the page.
    this.pendingAnchorHash = location.hash;
    if (this.pendingAnchorHash) {
      history.replaceState(null, '', location.pathname + location.search);
    }
  }

  init() {
    super.init();

    // this.pack.common.addScrollTarget(this);
    // this.pack.common.addEnterframeTarget(this);
  }

  reset() {
    super.reset();

    this.setVars();
    // this.pack.common.addScrollTarget(this);
    // this.pack.common.addEnterframeTarget(this);
  }

  destruct() {
    super.destruct();

    // this.pack.common.removeScrollTarget(this);
    // this.pack.common.removeEnterframeTarget(this);
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();
  }

  initEvents() {
    super.initEvents();

    // Runs after images/fonts have finished loading, so the target's
    // position is based on final layout rather than a mid-load one.
    window.addEventListener('load', this.anchorScroll.bind(this));
  }

  start() {}

  anchorScroll() {
    if (!this.pendingAnchorHash) return;

    const hash = this.pendingAnchorHash;
    this.pendingAnchorHash = null;

    const target = document.querySelector(hash);
    if (target) {
      const rect = target.getBoundingClientRect();
      // Shared GSAP-based smooth scroll (see Config.js) — same utility
      // Top.js's hero scroll button uses.
      this.pack.anchorScroll(rect.top + window.scrollY);
    }

    // Put the hash back in the URL (for shareability/back-forward) now
    // that our scroll already happened — replaceState never triggers a
    // native fragment jump on its own.
    history.replaceState(null, '', location.pathname + location.search + hash);
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
